import MOCK_SERVICES from './mockServicesData';

const SEED_FLAG = 'mockDataSeeded_v5';
const OLD_FLAGS = ['mockDataSeeded_v1', 'mockDataSeeded_v2', 'mockDataSeeded_v3', 'mockDataSeeded_v4'];

const seedMockDataIfNeeded = () => {
  // Skip only if flag is set AND real data exists.
  if (localStorage.getItem(SEED_FLAG)) {
    try {
      const existing = JSON.parse(localStorage.getItem('cscServices') || '[]');
      if (existing.length > 0) return;
    } catch { /* fall through and re-seed */ }
  }

  // Remove stale version flags.
  OLD_FLAGS.forEach((flag) => localStorage.removeItem(flag));

  // Preserve any services the CSC owner has already registered.
  let ownerServices = [];
  try {
    const existing = JSON.parse(localStorage.getItem('cscServices') || '[]');
    ownerServices = existing.filter((s) => s.addedByOwner);
  } catch { /* storage corrupt — start fresh */ }

  // Seed mock data first, then re-append owner services at the end.
  localStorage.setItem('cscServices', JSON.stringify([...MOCK_SERVICES, ...ownerServices]));
  localStorage.setItem(SEED_FLAG, 'true');
};

export default seedMockDataIfNeeded;
